import React from "react";
import { Box, Typography, Link, IconButton } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";

export default function OrderHelpSection() {
  return (
    <Box
      sx={{
        height: "100vh",
        overflowY: "scroll",
        scrollSnapType: "y mandatory",
      }}
    >
      {/* Order Now Section */}
      <Box
        sx={{
          height: "50vh",
          backgroundColor: "#642C34",
          color: "#fff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          scrollSnapAlign: "start",
          borderBottomLeftRadius: "20px",
          borderBottomRightRadius: "20px",
        }}
      >
        <ShoppingBagOutlinedIcon sx={{ fontSize: 70, mb: 2 }} />
        <Typography variant="h6" fontWeight={600}>
          Order Now
        </Typography>
        <Link
          href="#"
          underline="hover"
          sx={{ color: "#fff", mt: 0.5, fontSize: "0.9rem" }}
        >
          Tap To View Products
        </Link>
        <IconButton sx={{ mt: 2, color: "#fff" }}>
          <KeyboardArrowDown fontSize="large" />
        </IconButton>
      </Box>

      {/* Help & Support Section */}
      <Box
        sx={{
          height: "50vh",
          background: "linear-gradient(to bottom, #fff, #f9f6f6)",
          color: "#642C34",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          scrollSnapAlign: "start",
        }}
      >
        <IconButton sx={{ color: "#642C34", mb: 1 }}>
          <KeyboardArrowUp fontSize="large" />
        </IconButton>
        <HeadsetMicOutlinedIcon sx={{ fontSize: 70, mb: 2 }} />
        <Typography variant="h6" fontWeight={600}>
          Help & Support
        </Typography>
        <Link
          href="#"
          underline="hover"
          sx={{ color: "#642C34", mt: 0.5, fontSize: "0.9rem" }}
        >
          Tap To Get Assistance
        </Link>
      </Box>
    </Box>
  );
}
